import type { LoadLocation } from '@fv/models'
import {
  type ShipType,
  ShipTypeMapper,
  shipTypeLabels,
  shipTypes,
} from '@fv/models'
import type { DTO } from '@fv/models/core'

export type { ShipType }
export { shipTypeLabels, shipTypes }

export const shipTypeOptions = shipTypes.map(value => ({
  text: shipTypeLabels[value],
  value,
}))

export type QuoteStopType = 'origin' | 'destination'
export type SignatureAccessorialType =
  | 'adult-signature-required'
  | 'indirect-signature-required'
  | 'signature-required'

export type ShipmentLocation = DTO<LoadLocation>

export function displayShipType(shipType?: ShipType | '') {
  if (
    !shipType ||
    shipType === 'business dock' ||
    shipType === 'business no dock'
  ) {
    return null
  }

  return ShipTypeMapper.display(shipType) ?? null
}
